import { render } from "./PrintWrapper.vue?vue&type=template&id=af675614&scoped=true&ts=true"
import script from "./PrintWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrintWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./PrintWrapper.vue?vue&type=style&index=0&id=af675614&scoped=true&lang=css"
import "./PrintWrapper.vue?vue&type=style&index=1&id=af675614&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af675614"],['__file',"resources/js/vue/domain/admin/seg-frame-builder/print-page/PrintWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "af675614"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('af675614', __exports__)) {
    api.reload('af675614', __exports__)
  }
  
  module.hot.accept("./PrintWrapper.vue?vue&type=template&id=af675614&scoped=true&ts=true", () => {
    api.rerender('af675614', render)
  })

}


export default __exports__